export const SET_COMPANY = "COMPANY/SET_COMPANY"
export const SET_SOCIALS = "COMPANY/SET_SOCIALS"
export const SET_FACEBOOK_PIXEL = "COMPANY/SET_FACEBOOK_PIXEL"
export const SET_GOOGLE_ADS = "COMPANY/SET_GOOGLE_ADS"
export const SET_COMPANY_SETTINGS = "COMPANY/SET_COMPANY_SETTINGS"